import React, { useState } from "react";
import { API_URL } from '../config.js'; // Importiere die API URL

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit = async e => {
  e.preventDefault();
  setMsg("");
  const res = await fetch(`${API_URL}/api/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json();
  if (res.ok && data.token) {
    localStorage.setItem("jwt", data.token); // <-- Token speichern
    onLogin();
  } else {
    setMsg("Login fehlgeschlagen");
  }
};

  return (
    <section style={{maxWidth: 400, margin: "5rem auto", background: "#222", color: "#fff", borderRadius: 18, padding: "2.5rem 1.5rem"}}>
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Benutzername" style={{width:"100%",marginBottom:8}} />
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Passwort" style={{width:"100%",marginBottom:8}} />
        <button type="submit" style={{background:"#ffa726",color:"#222",fontWeight:"bold",borderRadius:8,padding:"0.7rem 2rem",border:"none",cursor:"pointer"}}>Login</button>
        <div style={{color:"#ffa726",marginTop:8}}>{msg}</div>
      </form>
    </section>
  );
};

export default AdminLogin;